document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.xeed-audition');
  if (!root) return;

  // JSが生きている時だけ js-fade / 入場アニメを有効化（CSS側は .-js でガード）
  root.classList.add('-js');

  // ---------- 応募受付の締切切替（締切後は「受付終了」へ） ----------
  // サーバー側でも is-closed を付けるが、キャッシュで開いた状態が残った場合に
  // 実時刻で補正する。?state=closed / ?state=open で強制（プレビュー確認用）。
  try {
    var forcedState = new URLSearchParams(window.location.search).get('state');
    var deadlineTs = new Date(root.getAttribute('data-deadline')).getTime();
    if (forcedState === 'closed') {
      root.classList.add('is-closed');
    } else if (forcedState === 'open') {
      root.classList.remove('is-closed');
    } else if (!isNaN(deadlineTs)) {
      if (Date.now() >= deadlineTs) {
        root.classList.add('is-closed');
      } else {
        // 閲覧中に締切を迎えたら自動で切替（setTimeout の上限内のときのみ）
        var untilDeadline = deadlineTs - Date.now();
        if (untilDeadline < 0x7fffffff) {
          setTimeout(function () {
            root.classList.add('is-closed');
          }, untilDeadline + 500);
        }
      }
    }
  } catch (e) {
    /* 締切判定に失敗してもページ自体は表示する */
  }

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

  // ---------- カード群のスタガー（[data-stagger] 内の .js-fade に時差） ----------
  root.querySelectorAll('[data-stagger]').forEach(function (group) {
    group.querySelectorAll('.js-fade').forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i * 90, 450) + 'ms';
    });
  });

  // ---------- 締切カウントダウン ----------
  try {
    var countdown = root.querySelector('[data-countdown]');
    if (countdown) {
      var deadline = new Date(countdown.getAttribute('data-countdown')).getTime();
      var fields = {
        days: countdown.querySelector('[data-cd="days"]'),
        hours: countdown.querySelector('[data-cd="hours"]'),
        min: countdown.querySelector('[data-cd="min"]'),
        sec: countdown.querySelector('[data-cd="sec"]'),
      };
      var pad = function (n) {
        return String(n).padStart(2, '0');
      };
      var canTickAnim = !prefersReduced && typeof countdown.animate === 'function';
      // 値が変わった桁だけ、すっと持ち上がるマイクロアニメ
      var setVal = function (el, v) {
        if (el.textContent === v) return;
        el.textContent = v;
        if (canTickAnim) {
          el.animate(
            [
              { opacity: 0.2, transform: 'translateY(0.3em)' },
              { opacity: 1, transform: 'none' },
            ],
            { duration: 320, easing: EASE }
          );
        }
      };
      var timer = null;
      var tick = function () {
        var diff = deadline - Date.now();
        if (diff <= 0) {
          fields.days.textContent = '00';
          fields.hours.textContent = '00';
          fields.min.textContent = '00';
          fields.sec.textContent = '00';
          countdown.classList.add('-closed');
          if (timer) clearInterval(timer);
          return false;
        }
        var sec = Math.floor(diff / 1000);
        setVal(fields.days, pad(Math.floor(sec / 86400)));
        setVal(fields.hours, pad(Math.floor((sec % 86400) / 3600)));
        setVal(fields.min, pad(Math.floor((sec % 3600) / 60)));
        setVal(fields.sec, pad(sec % 60));
        return true;
      };
      if (tick()) {
        timer = setInterval(tick, 1000);
      }
    }
  } catch (e) {
    /* カウントダウン失敗でも以降の処理は続行 */
  }

  // ---------- スクロール連動フェードイン（控えめ） ----------
  var fadeTargets = root.querySelectorAll('.js-fade');
  if (fadeTargets.length && 'IntersectionObserver' in window) {
    var fadeObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('-visible');
            fadeObserver.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    fadeTargets.forEach(function (el) {
      fadeObserver.observe(el);
    });
  } else {
    fadeTargets.forEach(function (el) {
      el.classList.add('-visible');
    });
  }

  // ---------- 追従CTA: KV表示中とフォーム表示中は隠す ----------
  var fixedCta = root.querySelector('#fixed-cta');
  var kv = root.querySelector('#kv');
  var entry = root.querySelector('#entry');
  if (fixedCta && kv && entry && 'IntersectionObserver' in window) {
    var kvVisible = true;
    var entryVisible = false;
    var updateCta = function () {
      fixedCta.classList.toggle('-hidden', kvVisible || entryVisible);
    };
    updateCta();
    new IntersectionObserver(
      function (entries) {
        kvVisible = entries[entries.length - 1].isIntersecting;
        updateCta();
      },
      { threshold: 0.2 }
    ).observe(kv);
    new IntersectionObserver(
      function (entries) {
        entryVisible = entries[entries.length - 1].isIntersecting;
        updateCta();
      },
      { threshold: 0.1 }
    ).observe(entry);
  }

  // ---------- HubSpotフォーム送信完了時: 完了メッセージまでスクロールを戻す ----------
  // 送信後にフォームが「応募完了」表示へ縮むと、ページ全体の高さが急減し、
  // 同じスクロール位置がフッター付近に取り残される（完了メッセージは画面外の上へ）。
  // 送信完了を検知して #entry を再表示し、ユーザーに完了が見えるようにする。
  if (entry) {
    var hubspot = entry.querySelector('.Entry-hubspot');
    var revealed = false;
    var revealEntry = function () {
      if (revealed) return;
      revealed = true;
      entry.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
      entry.setAttribute('tabindex', '-1');
      entry.focus({ preventScroll: true });
    };

    // 1) HubSpot公式フォームイベント（postMessage）
    window.addEventListener('message', function (event) {
      var d = event && event.data;
      if (d && d.type === 'hsFormCallback' && d.eventName === 'onFormSubmitted') {
        // DOM差し替え後にスクロールしたいので少し待つ
        setTimeout(revealEntry, 80);
      }
    });

    // 2) フォールバック: 完了表示への差し替えをDOM変化で検知
    if (hubspot && 'MutationObserver' in window) {
      new MutationObserver(function (mutations, obs) {
        var done = hubspot.querySelector(
          '.submitted-message, .hsfc-DonePage, .hsfc-Done, [data-hs-forms-submitted]'
        );
        if (done) {
          obs.disconnect();
          setTimeout(revealEntry, 80);
        }
      }).observe(hubspot, { childList: true, subtree: true });
    }
  }

  // ---------- ページ内アンカーのスムーススクロール ----------
  root.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (!href || href.length < 2) return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth' });
        // キーボード利用時にフォーカスも移動させる
        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
        }
        target.focus({ preventScroll: true });
      }
    });
  });
});
